<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/ruiminbo.png" alt="">
            <div class="company">湖南瑞民博环境工程有限公司</div>
          </div>
          <div class="labInfo">
            <span>畜禽养殖污水处理</span>
            <span>环境</span>
            <span>环保</span>
            <span>水处理</span>
          </div>
          <div class="companyInfo">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/hunan1.jpg" alt="">
            <div class="companyWord">湖南瑞民博环境工程有限公司是一家集技术研发、设备集成生产和工程建设于一体的现代化企业，公司于2016年在长沙成立，注册资金2000万元，全面贯彻实施ISO9001:2008质量管理体系，充分体现以客户为中心的经营管理理念，从方案设计、土建施工设计、设备采购制造、设备安装及调试、技术培训和售后维护等各个环节充分考虑及满足客户的真实需求，以先进的处理工艺、高标准的处理结果、稳定的处理流程被农业部确定为2017年全国畜禽养殖废弃物资源化利用大会现场考察项目，并获得全国养殖行业广泛关注，其承建项目先后获得前国务院副总理汪洋、前全国人大委员长张德江亲临现场参观检阅。获国家和各省市领导的现场视察与肯定和赞扬。公司以建设环保生态家园为己任，努力成为我国生态环境建设和保护的重要力量和领导品牌。</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/hunan2.jpg" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/hunan3.jpg" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
          <div class="info"> ①畜禽养殖污水处理 &nbsp;②净化、纯化水处理<br/>③城镇生活废水处理&nbsp; ④工矿企业废水处理 <br/>⑤污水处理设备集成&nbsp; ⑥水处理配件及耗材</div>
      </div>
      <div class='bottom'>
        <div class="title">合作公司logo</div>
        <div class="info">
          <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/logo/6.jpg" alt="" style="width:120px;height:30px;display: inline-block;margin-right: 3px;">
          <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/logo/1.jpg" alt="">
          <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/logo/2.jpg" alt="">
          <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/logo/3.jpg" alt="">
          <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/logo/4.jpg" alt="">
          <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/logo/5.jpg" alt="">
        </div>
      </div>
      <footer class="nongmu-footer">
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt>
          <dd><a href="http://www.ruiminbo.cn/">http://www.ruiminbo.cn/</a></dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt>
          <dd>湖南省长沙市雨花区洞井中路411号园康星都荟5栋701（仙本娜酒店7楼）</dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';

</style>
